import ProductListItem from '../ProductListItem/index.vue';

export default {
  name: 'ProductList',
  data() {
    return {
      className: 'app__product__list',
    };
  },
  components: {
    ProductListItem,
  },
  computed: {
    listClassName() {
      return `${this.className}`;
    },
    itemClassName() {
      return `${this.className}__item`;
    },
    noResultsClassName() {
      return `${this.className}__no__results`;
    },
    showNoResultsMessage() {
      return this.showNoResults && !this.products.length;
    },
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    showNoResults: {
      type: Boolean,
      default: false,
    },
    noResultsMessage: {
      type: String,
      default: '',
    },
  },
};
